import { render, staticRenderFns } from "./RadioButtonComponent.vue?vue&type=template&id=383f1db6&scoped=true&"
import script from "./RadioButtonComponent.vue?vue&type=script&lang=js&"
export * from "./RadioButtonComponent.vue?vue&type=script&lang=js&"
import style0 from "./RadioButtonComponent.vue?vue&type=style&index=0&id=383f1db6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383f1db6",
  null
  
)

export default component.exports